<template>
    <el-dialog title="字段隐显规则" width="750px" append-to-body :close-on-click-modal="false" :visible.sync="visible">
        <div class="m_b1 fontSize12">满足以下
            <el-select class="conditionSel" v-model="form.ruleWhere" size="mini">
                <el-option label="所有" value="0"></el-option>
                <el-option label="任一" value="1"></el-option>
            </el-select>
            条件时
        </div>
        <el-button type="primary" @click="add()" size="small">添加条件</el-button>
        <el-form class="m_t1" size="mini" :model="form" :inline="true" ref="form" label-width="0px">
            <div v-for="(item, index) in form.metadataBasicDataShowRuleDetailList" :key="index">
                <el-form-item :prop="`metadataBasicDataShowRuleDetailList.${index}.basicDataDetailId`"
                              :rules="[{required: true, message: '元数据不能为空', trigger: 'change'}]">
                    <el-select v-model="item.basicDataDetailId" placeholder="请选择本模板下的元数据" filterable
                               @change="archivesChange(item)">
                        <el-option v-for="c in config" :key="c.id" :label="c.basicRename"
                                   :value="c.id" :disabled="c.disabled"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :prop="`metadataBasicDataShowRuleDetailList.${index}.basicCondition`"
                              :rules="[{required: true, message: '条件不能为空', trigger: 'change'}]">
                    <el-select v-model="item.basicCondition" placeholder="请选择">
                        <el-option label="包含" value="包含"></el-option>
                        <el-option label="不包含" value="不包含"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :prop="`metadataBasicDataShowRuleDetailList.${index}.metadataRangeId`"
                              :rules="[{required: true, message: '筛选值不能为空', trigger: 'change'}]">
                    <el-select class="valItem" v-model="item.metadataRangeId" multiple placeholder="请选择筛选值" filterable
                               clearable :multiple-limit="item.basicAssemblyId == '10' ? 1 : 0"
                               @remove-tag="metadataRangeIdsChange($event, item)">
                        <el-option v-for="(v,i) in item.basicRangeList" :key="i"
                                   :label="v.basicRange"
                                   :value="v.metadataRangeId" :disabled="v.showDisabled"></el-option>
                    </el-select>
                </el-form-item>
                <el-link class="m_t1" icon="el-icon-delete" type="danger" :underline="false"
                         @click="del(index)"></el-link>
            </div>
            <div class="fontSize12">显示当前字段</div>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
                loading: false,
                method: '',
                row: {},
                form: {
                    id: '',
                    basicDataDetailId: '',
                    metadataBasicDataShowRuleDetailList: [],
                    ruleWhere: '0'
                },
                metadataInfo: {},
                config: [],
                selArchives: [],
            }
        },
        methods: {
            init(item, method, metadataInfo) {
                this.method = method
                this.metadataInfo = metadataInfo
                this.form.metadataBasicDataShowRuleDetailList = []
                this.form.basicDataDetailId = metadataInfo.id
                this.form.basicDataId = metadataInfo.basicDataId
                if (item) {
                    this.row = item
                    this.form.id = item.id
                } else {
                    this.form.id = ''
                    this.row = {}
                }
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.form.resetFields();
                    this.getSelectAllByBasicDataId()
                })
            },
            // 查询所有元数据
            getSelectAllByBasicDataId() {
                this.loading = true
                this.$axios(this.api.metadata.selectRangsByBasicDataId, {
                    basicDataDetailId: this.metadataInfo.id,
                    basicDataId: this.metadataInfo.basicDataId
                }).then(res => {
                    if (res.status) {
                        this.config = res.data.filter(v => v.id != this.metadataInfo.id)
                        this.config.map(item => {
                            this.$set(item, 'disabled', false)
                        })
                        if (this.method != 'add') {
                            this.row.metadataBasicDataShowRuleDetailList.map((item, index) => {
                                let val = this.config.filter(v => v.id == item.basicDataDetailId)[0]
                                this.$set(item, 'basicRangeList', val.basicRangeList)
                                this.$set(item, 'basicAssemblyId', val.basicAssemblyId)
                            })
                            this.$nextTick(() => {
                                let p = JSON.parse(JSON.stringify(this.row))
                                this.row.metadataBasicDataShowRuleDetailList.map((item, index) => {
                                    let arr = []
                                    item.basicRanges.map(v => {
                                        arr.push(v.metadataRangeId)
                                    })
                                    p.metadataBasicDataShowRuleDetailList[index].metadataRangeId = arr
                                })
                                this.form = this.recover(this.form, p)
                                this.$nextTick(() => {
                                    this.filterBasicData()
                                })
                            })
                        }
                    }
                    this.loading = false
                })
            },
            // 选择元数据
            archivesChange(item) {
                let selArchives = this.config.filter(v => v.id == item.basicDataDetailId)[0]
                this.$set(item, 'basicAssemblyId', selArchives.basicAssemblyId)
                this.$set(item, 'basicRangeList', selArchives.basicRangeList)
                this.$set(item, 'basicCondition', '')
                this.$set(item, 'metadataRangeId', [])
                this.filterBasicData()
            },
            // 选择值域
            metadataRangeIdsChange(id, item) {
                if(this.method == 'edit') {
                    let val = item.basicRangeList.filter(v => v.metadataRangeId == id)[0]
                    this.$set(val, 'showDisabled', false)
                }
            },
            // 过滤元数据名称
            filterBasicData() {
                this.selArchives = []
                this.form.metadataBasicDataShowRuleDetailList.map(v => {
                    if (v.basicDataDetailId) {
                        this.selArchives.push(v.basicDataDetailId)
                    }
                })
                this.config.map(item => {
                    this.$set(item, 'disabled', false)
                })
                this.$nextTick(() => {
                    for (let id of this.selArchives) {
                        let itemJson = this.config.find((item) => {
                            return item.id === id
                        });
                        this.$set(itemJson, 'disabled', true)
                    }
                })
            },
            // 删除筛选条件
            del(index) {
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.form.metadataBasicDataShowRuleDetailList.splice(index, 1);
                })
            },
            // 添加条件
            add() {
                this.form.metadataBasicDataShowRuleDetailList.push({
                    basicDataDetailId: '',
                    basicCondition: '',
                    metadataRangeId: [],
                    basicRangeList: [],
                })
            },
            // 表单提交
            doSubmit() {
                if (!this.form.metadataBasicDataShowRuleDetailList.length) {
                    this.$message.warning('请添加字段隐显规则')
                    return
                }
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.$axios(this.api.metadata.showRuleSave, this.form, 'post').then(data => {
                            if (data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refreshDataList')
                            } else {
                                this.$message.error(data.msg)
                            }
                            this.loading = false
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .condition {
        font-size: 12px;
    }

    .conditionSel {
        width: 80px !important;
        margin: 0 5px;
    }

    .range {
        width: 100% !important;
    }

    .range >>> .el-form-item__content {
        width: 76% !important;
    }


</style>
